module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image18.acbed743.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image18.png
// module id = 2586
// module chunks = 0